function onReady(cb) {
  if (document.readyState !== 'loading') cb();
  else document.addEventListener('DOMContentLoaded', cb);
}

function waitFor(selector, cb) {
  const timer = setInterval(function () {
    if (document.querySelector(selector)) {
      clearInterval(timer);
      cb();
    }
  }, 200);
}

function unwrap(el) {
  while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el);
  el.remove();
}

function buttonToSpan(el) {
  const span = document.createElement('span');
  span.innerHTML = el.innerHTML;
  const cls = el.getAttribute('class');
  const type = el.getAttribute('type');
  if (cls) span.setAttribute('class', cls);
  if (type) span.setAttribute('type', type);
  el.replaceWith(span);
}


onReady(function () {
  document.querySelectorAll('br').forEach(function (br) {
    br.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll('a[href="/pages/about-us"]').forEach(function (link) {
    if (link.textContent.includes('LEARN MORE')) {
      link.setAttribute('aria-label', 'LEARN MORE about us');
    }
  });

  document.querySelectorAll('.warn a').forEach(function (link) {
    link.setAttribute('aria-label', 'Email Address:support@brooklyncandlestudio.com, This Link Will open in a new tab');
  });

  document.querySelectorAll('.prose.text-center h1:empty, .prose.text-center h2:empty, .prose.text-center h3:empty, .prose.text-center h4:empty, .prose.text-center h5:empty, .prose.text-center h6:empty').forEach(function (h) {
    h.remove();
  });

  document.querySelectorAll('#contact_form button').forEach(function (button) {
    button.setAttribute('aria-label', 'Send message button. When you click on this button, the page will be refreshed, and focus will go to the top of the page.');
  });
});


document.addEventListener("DOMContentLoaded", function() {
  var thirdPartyLinks = document.querySelectorAll('p a, .footer__block.footer__block--links a');

  // Loop through each link
  thirdPartyLinks.forEach(function(link) {
      // Check if the link leads to a third-party website
      if (isThirdParty(link.href)) {
          // Add the target="_blank" attribute
          link.setAttribute('target', '_blank');

          // Add the text indicating it will open in a new tab
          var existingText = link.textContent.trim();
          var newText = existingText + ', This Link will open in a new tab';
          link.setAttribute('aria-label', newText);
      }
  });

  // Function to check if a link is from a third-party website
  function isThirdParty(url) {
      return !url.includes('brooklyncandlestudio.com');
  }
});


waitFor('a', function () {
  document.querySelectorAll('a').forEach(function (a) {
    if (a.innerHTML.trim() === '' || (a.children.length === 0 && a.textContent.trim() === '')) {
      a.remove();
    }
  });
});

onReady(function () {
  document.querySelectorAll('a[href="https://brooklyncandlestudio.com/products/deluxe-candle-of-the-month-subscription?selling_plan=3503521895"]').forEach(function (a) {
    const mediaGrid = a.querySelector('media-grid');
    if (mediaGrid && mediaGrid.childNodes.length === 0) {
      a.remove();
    }
  });
});

onReady(function () {
  document.querySelectorAll('.prose.text-center h5').forEach(function (h5) {
    const p = document.createElement('p');
    p.className = 'hf-to-p';
    p.innerHTML = h5.innerHTML;
    h5.replaceWith(p);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.getElementById('back-to-top');

  window.addEventListener('scroll', function() {
      if (window.scrollY > 300) {
          backToTopButton.style.display = 'block';
      } else {
          backToTopButton.style.display = 'none';
      }
  });

  backToTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Set focus to the top of the page after scrolling
      setTimeout(function() {
          document.getElementById('go-top1').focus(); // Ensure this element exists
      }, 600); // Adjust the timeout duration to match the scroll duration
  });
});


document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.getElementById('{{ carousel_id }}');
  var prevButton = document.querySelector('.carousel-control.prev');
  var nextButton = document.querySelector('.carousel-control.next');

    prevButton && prevButton.addEventListener('click', function() {
    carousel.previous();
  });

  nextButton && nextButton.addEventListener('click', function() {
    carousel.next();
  });
});

onReady(function () {
  document.querySelectorAll('h4:empty').forEach(function (h4) {
    h4.remove();
  });
});

onReady(function () {
  document.querySelectorAll('.table-scroller table').forEach(function (table) {
    table.setAttribute('role', 'presentation');
  });
});

waitFor('.gt_redirectpopup_1677728147506_image', function () {
  document.querySelectorAll('.gt_redirectpopup_1677728147506_image').forEach(function (img) {
    img.setAttribute('alt', 'A hand lighting a candle labeled Santorini next to a vase with pink roses on a light-colored wooden surface.');
  });
});

waitFor('img.gt_redirectpopup_1677728147506_logo', function () {
  document.querySelectorAll('img.gt_redirectpopup_1677728147506_logo').forEach(function (img) {
    img.setAttribute('alt', 'Brooklyn Candle Studio logo');
  });
});

onReady(function () {
  const heading = document.querySelector('.blg .h2');
  const button = document.querySelector('.blg .button');
  if (button) {
    const headingText = heading ? heading.textContent : '';
    button.setAttribute('aria-label', button.textContent + ' about ' + headingText);
  }
});


waitFor('.accordion__content.prose a', function () {
  document.querySelectorAll('.accordion__content.prose a').forEach(function (a) {
    if (a.children.length === 0 || (a.children.length === 1 && a.children[0].tagName === 'BR')) {
      a.remove();
    }
  });
});

onReady(function () {
  document.querySelectorAll('.cc-list .button').forEach(buttonToSpan);
});

onReady(function () {
  document.querySelectorAll('.prose.prose--tight.place-self-start-center.text-center .button').forEach(buttonToSpan);
});

onReady(function () {
  document.querySelectorAll('.blg .button').forEach(buttonToSpan);
});


onReady(function () {
  document.querySelectorAll('.accordion__content.prose a').forEach(function (a) {
    // Effectively empty: no text but has child elements
    if (a.textContent.trim() === "" && a.children.length > 0) {
      unwrap(a);
    }
  });
});


onReady(function () {
  document.querySelectorAll('div#sgp a').forEach(function (a) {
    // Effectively empty: no text but has child elements
    if (a.textContent.trim() === "" && a.children.length > 0) {
      unwrap(a);
    }
  });
});


waitFor('.js-seo-text-trigger', function () {
  document.querySelectorAll('.js-seo-text-trigger').forEach(function (trigger) {
    const moreText = trigger.dataset.more;
    const lessText = trigger.dataset.less;
    const span = trigger.querySelector('span');
    const currentText = span ? span.textContent : '';

    if (currentText === moreText) {
      trigger.setAttribute('aria-label', 'Click here to ' + moreText);
    } else if (currentText === lessText) {
      trigger.setAttribute('aria-label', 'Click here to ' + lessText);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();

      const newText = (span.textContent === moreText) ? lessText : moreText;
      span.textContent = newText;

      trigger.setAttribute('aria-label', 'Click here to ' + newText);
    });
  });
});

waitFor('.qab_slide_message a', function () {
  document.querySelectorAll('.qab_slide_message a').forEach(function (a) {
    // Effectively empty: no text but has child elements
    if (a.textContent.trim() === "" && a.children.length > 0) {
      unwrap(a);
    }
  });
});
